import { combineReducers } from 'redux';

import onboarding from './onboarding';

const reducers = combineReducers({ onboarding });

export default reducers;
